import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCreditBalance, fetchActiveAiModels } from "actions/AiFeatures";

const useIsGoalsAiEnabled = () => {
  const dispatch = useDispatch();
  const { accountId } = useSelector((s) => s.user);
  const accessibleKeys = useSelector(
    (s) => s.ProductPermissions.accessible_product_keys
  );
  const creditBalance = useSelector(
    (s) =>
      s.aiFeatures.credits.creditBalance?.pbx_credits?.pbx_credit_balance ?? 0
  );
  const activeAiModels = useSelector(
    (s) => s.aiFeatures.aiConfigurations.activeAiModels
  );

  const [isAiCheckLoading, setIsAiCheckLoading] = useState(true);

  useEffect(() => {
    if (!accessibleKeys?.includes("peoplebox_ai") || !accountId) {
      setIsAiCheckLoading(false);
      return;
    }

    dispatch(fetchCreditBalance(accountId));
    dispatch(
      fetchActiveAiModels(accountId, { enabled_for_goals: true })
    ).finally(() => setIsAiCheckLoading(false));
  }, [accountId, accessibleKeys, dispatch]);

  const isGoalsAiEnabled =
    accessibleKeys?.includes("peoplebox_ai") &&
    creditBalance > 0 &&
    Array.isArray(activeAiModels) &&
    activeAiModels.length > 0;

  return { isGoalsAiEnabled, isAiCheckLoading };
};

export default useIsGoalsAiEnabled;
